import { Box, Button, Card, Typography } from "@mui/material";
import { AddIcon } from "../../icons";
import { formatDate } from "../../utils/utils";
import { useState } from "react";
import ProjectCreateModal from "../ProjectCreateModal";
import { StorageIcon } from "common-lib";

interface DatasetCardProps {
  item: DatasetItem;
  // setOpenModal: (open: boolean) => void;
}

export default function DatasetCard({ item }: DatasetCardProps) {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <div
        onClick={() => {
          setOpenModal(true);
        }}
        style={{
          background: "var(--dk-surface, #fff)",
          borderRadius: "10px",
          border: "1px solid var(--dk-border, #e5e7eb)",
          padding: "14px",
          cursor: "pointer",
          transition: "all .18s",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          position: "relative",
          overflow: "hidden",
        }}
        onMouseEnter={(e) => {
          const el = e.currentTarget as HTMLElement;
          el.style.borderColor = "#93c5fd";
          el.style.boxShadow = "0 4px 16px rgba(59,130,246,0.08)";
          el.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          const el = e.currentTarget as HTMLElement;
          el.style.borderColor = "#e5e7eb";
          el.style.boxShadow = "none";
          el.style.transform = "none";
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginTop: "4px" }}>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "8px",
              background: "var(--dk-info-bg, #eff6ff)",
              border: "1px solid var(--dk-info-border, #bfdbfe)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <StorageIcon sx={{ fontSize: 16, color: "#3b82f6" }} />
          </div>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 600,
              padding: "3px 7px",
              borderRadius: "20px",
              background: "#f0fdf4",
              border: "1px solid #bbf7d0",
              color: "#16a34a",
            }}
          >
            {item.fileData.type}
          </span>
        </div>
        <div>
          <p
            style={{
              fontSize: "13px",
              fontWeight: 700,
              color: "var(--dk-text, #111827)",
              margin: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={item.name}
          >
            {item.name}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            padding: "8px 10px",
            background: "var(--dk-surface-2, #f9fafb)",
            borderRadius: "7px",
            border: "1px solid var(--dk-border, #f3f4f6)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "2px" }}>
            <span style={{ fontSize: "10px", color: "var(--dk-text-3, #9ca3af)", fontWeight: 500 }}>라벨링</span>
            <span style={{ fontSize: "11px", fontWeight: 700, color: "var(--dk-text-2, #374151)" }}>
              {item.fileData.labeled_files ?? 0} / {item.fileData.total_files || "0"}
            </span>
          </div>
          <div
            style={{ width: "100%", height: "4px", borderRadius: "999px", background: "var(--dk-surface-3, #e5e7eb)", overflow: "hidden" }}
          >
            <div
              style={{
                height: "100%",
                borderRadius: "999px",
                background: "linear-gradient(90deg, #3b82f6, #60a5fa)",
                width: `${
                  item.fileData.total_files
                    ? Math.round(((item.fileData.labeled_files ?? 0) / item.fileData.total_files) * 100)
                    : 0
                }%`,
                transition: "width .4s ease",
              }}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "4px" }}>
            <span style={{ fontSize: "10px", color: "var(--dk-text-3, #9ca3af)" }}>생성일</span>
            <span style={{ fontSize: "10px", color: "var(--dk-text-2, #6b7280)" }}>{formatDate(item.create_at.toString())}</span>
          </div>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpenModal(true);
          }}
          style={{
            width: "100%",
            padding: "7px 0",
            borderRadius: "7px",
            border: "1px solid var(--dk-info-border, #bfdbfe)",
            background: "var(--dk-info-bg, #eff6ff)",
            fontSize: "12px",
            fontWeight: 600,
            color: "#3b82f6",
            cursor: "pointer",
            transition: "all .15s",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
          }}
          onMouseEnter={(e) => {
            const el = e.currentTarget as HTMLElement;
            el.style.background = "#3b82f6";
            el.style.color = "#fff";
            el.style.borderColor = "#3b82f6";
          }}
          onMouseLeave={(e) => {
            const el = e.currentTarget as HTMLElement;
            el.style.background = "#eff6ff";
            el.style.color = "#3b82f6";
            el.style.borderColor = "#bfdbfe";
          }}
        >
          <AddIcon sx={{ fontSize: 14 }} />
          프로젝트 생성
        </button>
      </div>

      {openModal && <ProjectCreateModal open={openModal} setOpen={setOpenModal} item={item} />}
    </>
  );
}
